import React, { Component } from 'react';
import { Client, Login, ScrollToTop, AuthRequired, Admin, NotFound } from "./Components";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import $ from "jquery";

export default class App extends Component {
    componentDidMount(){
        $.ajax({
            type: "POST",
            url: 'https://us-central1-portfolio-336c8.cloudfunctions.net/getSaltedPW',
            data: {body:{pw:'fwefewcwegwe'}},
            success: data=>{console.log(data);}
          });
    }
    render() {
        return (
            <Router>
                <div>
                    <ScrollToTop />
                    <Switch>
                        <Route exact path="/" component={Client} />
                        <Route path="/login" component={Login} />
                        <Route path="/admin" component={AuthRequired(Admin)} />
                        <Route component={NotFound} />
                    </Switch>
                </div>
            </Router>
        );
    }
}


// WEBPACK FOOTER //
// ./src/App.js